import {useEffect, useState} from 'react'
import {Lang} from 'yougile-lang'
import {EmailChangeConfirmReq, EmailChangeResp} from 'yougile-model'
import {Backend} from '@common/backend'
import {MessageBox} from '@components/message-box'
import {PageService} from '@extensions/page-service'

type State = 'pending' | 'success' | 'fail'

export const useEmailChange = (): State => {
  const [state, setState] = useState<State>('pending')

  useEffect(() => {
    const req: EmailChangeConfirmReq = {
      token: PageService.getSearchParam('token')
    }
    void Backend.postJSON<EmailChangeResp>('/data/email-change/confirm', req, {
      rawErrors: true
    }).then(res => {
      if (res.result === 'ok') {
        setState('success')
      } else {
        const error = res.error ?? 'errorUnknown'
        MessageBox.show(Lang.tryLocalize(error), 'danger')
        setState('fail')
      }
    })
  }, [setState])

  return state
}
